module.exports = __webpack_public_path__ + "img/latest_news.bd453c1.png";